module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.main) ? _c('main', {
    staticClass: "modulemain"
  }, [(_vm.main.name) ? _c('h1', {
    staticClass: "modulemain__title"
  }, [_vm._v(_vm._s(_vm.main.name))]) : _vm._e(), (_vm.main.announce) ? _c('p', {
    staticClass: "modulemain__announce"
  }, [_vm._v(_vm._s(_vm.main.announce))]) : _vm._e(), _c('MainFooterLayout', [_c('MainFooterBlock', {
    attrs: {
      "name": "Продолжительность",
      "type": "time"
    }
  }, [_vm._v(_vm._s(_vm.main.weeks))]), _c('MainFooterBlock', {
    attrs: {
      "name": "Количество лекций",
      "type": "programm"
    }
  }, [_vm._v(_vm._s(_vm.main.lectureLessonsCount))]), _c('MainFooterBlock', {
    attrs: {
      "name": "Количество практический занятий",
      "type": "group"
    }
  }, [_vm._v(_vm._s(_vm.main.practicalLessonsCount))])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e1aa834","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/modulemain/ModuleMain.vue
// module id = eaea88bac26ffbed4bad
// module chunks = 0